import { Typography, Checkbox, Row, Col } from 'antd';

const { Title } = Typography;

const TitleComponent = ({ title, hasCheckbox, checkboxLabel, checkboxProps }) => (
  <div
    style={{
      backgroundColor: '#F4F6FF',
      padding: 0,
      borderRadius: 0,
      border: '1px solid rgba(180,180,180,0.34)',
      display: 'flex',
      alignItems: 'stretch',
      minHeight: 43, // ensures consistent height
      //maxWidth: '537px',
    }}
  >
    <div
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        padding: '10px 12px',
      }}
    >
      <Title
        level={5}
        style={{
          margin: 0,
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        {title}
      </Title>
    </div>
    {hasCheckbox && (
      <div
        style={{
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          padding: '0 12px',
          minWidth: 0,
        }}
      >
        <Checkbox
          style={{
            width: 16,
            height: 16,
            border: '1px solid rgba(174, 172, 172, 1)',
            borderRadius: 4,
            marginRight: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          {...checkboxProps}
        />
        <span style={{ fontSize: 12 }}>{checkboxLabel}</span>
      </div>
    )}
  </div>
);

export default TitleComponent;